import React, { useState } from 'react';
import { Container, Box, Tabs, Tab } from '@mui/material';
import TranslatePage from './TranslatePage';
import EditPage from './EditPage';
import TopBar from './components/TopBar';
import translations from './localizations';
import SplitPage from './SplitPage';
import JoinPage from './JoinPage';

function App() {
  const [activeTab, setActiveTab] = useState('edit'); // Đặt 'edit' làm tab mặc định
  const [language, setLanguage] = useState('vi');

  const t = (key) => translations[language][key] || key;

  return (
    <>
      <TopBar language={language} setLanguage={setLanguage} />
      <Container className="App" maxWidth="md">
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
          <Tabs value={activeTab} onChange={(e, newValue) => setActiveTab(newValue)}>
            <Tab label={t('editTab')} value="edit" /> {/* Đổi vị trí tab Hiệu đính lên trước */}
            <Tab label={t('translateTab')} value="translate" />
            <Tab label={t('splitTab')} value="split" />
            <Tab label={t('joinTab')} value="join" />
          </Tabs>
        </Box>

        {activeTab === 'edit' && <EditPage language={language} />}
        {activeTab === 'translate' && <TranslatePage language={language} />}
        {activeTab === 'split' && <SplitPage language={language} />}
        {activeTab === 'join' && <JoinPage language={language} />}
      </Container>
    </>
  );
}

export default App;
